export default "__VITE_ASSET__245ae85c__"